<template>
  <div>
    <a-table :scroll="{ x: 1200 }" :pagination="pagination" :columns="columns" size="middle" :data-source="sourceData" row-key="index" :loading="loading" @change="handlePageChange">
      <template slot="id" slot-scope="text, record"> {{ `MR-${record.id}` }}<a-tag v-if="record.read === true" class="read-tag">已读</a-tag> </template>
      <template slot="customTitle" slot-scope="text, record">
        <a class="custom-link" :href="link(record)" target="_blank">{{ record.title }}</a>
      </template>
      <template slot="action" slot-scope="text, record">
        <a :disabled="deletedDisabled(record)" @click="onDelete(record)">删除</a>
      </template>
      <template slot="businessRequirements" slot-scope="text, record">
        <a v-for="(item, index) in record.businessRequirements" :key="index" :href="requirementLink(item)" target="_blank">BR-{{ item }} </a>
      </template>
    </a-table>
    <action-record-modal ref="actionRecordRef" />
  </div>
</template>

<script>
import { queryDocument, deleteDocument } from '@/api/business/document';

import ActionRecordModal from '@/pages/business/document/components/ActionRecordModal';

const columns = [
  {
    width: 120,
    title: 'ID',
    scopedSlots: { customRender: 'id' }
  },
  {
    ellipsis: true,
    title: '标题',
    scopedSlots: { customRender: 'customTitle' }
  },
  {
    width: 300,
    title: '关联业务需求',
    scopedSlots: { customRender: 'businessRequirements' }
  },
  {
    width: 90,
    title: '创建人',
    customRender: (_, record) => record.creator.nickname || '--'
  },
  {
    width: 165,
    title: '创建时间',
    key: 'createdTime',
    dataIndex: 'createdTime'
  },
  {
    width: 165,
    title: '更新时间',
    key: 'updatedTime',
    dataIndex: 'updatedTime'
  },
  {
    width: 60,
    title: '操作',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: { ActionRecordModal },
  data() {
    return {
      columns,
      loading: true,
      sourceData: [],
      pagination: {
        size: 'large',
        total: 0,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      filterForm: {
        keyword: '',
        category: 'mrd',
        creator: 0,
        about: true
      }
    };
  },
  computed: {
    /**
     * 计算MRD详情链接地址
     */
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:document:detail',
          params: { id: record.id }
        }).href;
      };
    },
    /**
     * 计算业务需求链接地址
     */
    requirementLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record }
        }).href;
      };
    },
    /**
     * 计算删除按钮是否置灰，当用户与MRD创建人不是同一个时，置灰删除按钮
     */
    deletedDisabled() {
      return record => {
        return record.creator.id !== this.$store.state.userInfo.id;
      };
    }
  },
  methods: {
    /**
     * 点击查询事件
     * @param {*} filter
     */
    onFilter(filter) {
      this.loading = true;
      this.filterForm = filter;
      this.pagination.current = 1;
      this.queryDocumentList();
    },

    /**
     * 查询文档列表
     */
    queryDocumentList() {
      queryDocument({
        ...this.filterForm,
        unbound: false,
        pageSize: this.pagination.pageSize,
        pageNumber: this.pagination.current
      })
        .then(res => {
          this.loading = false;
          this.sourceData = res.data.items.map((item, index) => ({ index, ...item }));
          this.pagination.total = res.data.total;
          this.$emit('setCount', { 0: res.data.total });
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 分页操作触发事件
     * @param {*} pagination
     */
    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.queryDocumentList();
    },

    /**
     * 点击删除事件
     * @param {*} record
     */
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该MRD文档吗?',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        async onOk() {
          deleteDocument({ id: record.id }).then(() => {
            self.$message.success('删除成功');
            self.queryDocumentList();
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.read-tag {
  margin-right: 0px;
  margin-left: 2px;
  padding: 2px;
  line-height: 10px;
  font-size: 10px;
}
</style>
